import { AUTHENTICATED_ENTRY, REDIRECT_URL_KEY } from 'configs/AppConfig';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useSearchParams } from 'react-router-dom';

// Honor the ?redirect= written by ProtectedRoute, but only for same-origin
// paths. Prefix checks alone are bypassable — '/\evil.com' starts with '/'
// yet resolves cross-origin — so resolve against the real origin and compare.
const isSafeInternalPath = (redirect) => {
  if (!redirect || !redirect.startsWith('/') || redirect.startsWith('//')) {
    return false;
  }
  try {
    return (
      new URL(redirect, window.location.origin).origin ===
      window.location.origin
    );
  } catch (err) {
    return false;
  }
};

const PublicRoute = () => {
  const { token } = useSelector((state) => state.auth);
  const [searchParams] = useSearchParams();

  if (!token) {
    return <Outlet />;
  }

  const redirect = searchParams.get(REDIRECT_URL_KEY);

  return (
    <Navigate
      to={isSafeInternalPath(redirect) ? redirect : AUTHENTICATED_ENTRY}
      replace
    />
  );
};

export default PublicRoute;
